export class CONSTANTS {
    //Bottom-Bar URLs
    private static baseUrl: string = "https://aiddevs.com/"
    static privacyStatement: string = this.baseUrl + "datenschutzerklaerung-software/"
    static imprint: string = this.baseUrl + "impressum/"
    static licenses: string = "/3rdpartylicenses.txt"
    static termsAndConditions: string = this.baseUrl + "agbs/"

    // Interceptor Exceptions
    public static httpInterceptorExceptions: string[] = []

    // error messages
    static loginError: string = 'Ungültige Logindaten. Bitte überprüfe Deinen Benutzernamen und Passwort.'
    static resetPasswordError: string = 'Ungültige Eingabe. Es existiert kein Konto mit der angegebenen E-Mail-Adresse.'
    static accountExistsError: string = 'Ungültige Eingabe. Es existiert bereits ein Konto mit der angegebenen E-Mail-Adresse. Überprüfe deine Angaben oder benutze die Passwort vergessen Funktion.'
    static accountsMayExistError: string = 'Ungültige Eingabe. Es existiert bereits ein Konto mit einem oder mehreren der angegebenen E-Mail-Adressen. Überprüfe die Angaben.'
    static companyLimitReachedError: string = 'Angestelltenlimit erreicht. Dem Unternehmen können aktuell keine weiteren Angestellten beitreten.'
    static unauthenticatedError: string = 'Unauthorisierter Zugriff. Du wurdest automatisch ausgeloggt.'
    static manipulationError: string = 'Du wurdest aus Sicherheitsgründen automatisch ausgeloggt.'
    static unknownError: string = 'Es ist ein unbekannter Fehler aufgetreten.'
    static errorMessageNoBranchOffice: string = 'Es wurde keine Niederlassung mit diesem Code gefunden. Bitte überprüfe deine Eingabe.'
    static duplicateNameError: string = 'Es existiert bereits ein Dokument mit dem angegebenen Titel.'
    static serverError: string = 'Es ist ein Serverfehler aufgetreten. Um uns bei der Fehlersuche zu unterstützen kannst du uns eine E-Mail mit den relevanten Informationen senden.'
    static fileError: string = 'Beim Erstellen der Datei ist ein Fehler aufgetreten.'
    static passwordAuthFailedMessage: string = 'Authentifizierungstoken abgelaufen oder fehlerhaft.'
    static ressourceMissingMessage: string = "Die angeforderte Ressource existiert nicht."

    //Forms
    static maxInput: number = 500
}
